<script setup>
import {
    computed,
} from 'vue';
import AppIcon from '../app/AppIcon';
import {
    useUniqueId,
} from '../../../composables/unique-id';

const props = defineProps({
    name: {
        type: String,
    },
    modelValue: {
        type: [Boolean, String, Number, Array],
        default: false,
    },
    error: {
        type: Boolean,
        default: false,
    },
    trueValue: {
        type: [Boolean, String, Number],
        default: true,
    },
    falseValue: {
        type: [Boolean, String, Number],
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);

const shouldBeChecked = computed(() => props.modelValue === (props.trueValue));

const updateInput = (e) => {
    const isChecked = e.target.checked;
    emit('update:modelValue', isChecked ? props.trueValue : props.falseValue);
};

const { id } = useUniqueId();
</script>

<template>
    <label
        class="k-c-checkbox c-formCheckbox"
        :class="{'k-c-checkbox--error': error}"
        :for="id"
    >
        <input
            :id="id"
            :name="name"
            :checked="shouldBeChecked"
            class="k-c-checkbox__input"
            type="checkbox"
            @change="updateInput"
        >
        <div
            :class="{
                'is-checked': shouldBeChecked
            }"
            class="k-c-checkbox__box c-formCheckbox__box"
            data-qa="icon"
        >
            <AppIcon
                class="k-c-checkbox__icon"
                name="check"
            />
        </div>
        <div class="k-c-checkbox__label c-formCheckbox__label">
            <slot/>
        </div>
    </label>
</template>

<style lang="scss">
// 1. Increase specificity to override styles from Global-Styles (this component should be refactored in the future
//    so that this is no longer necessary)
.c-formCheckbox {
    $root: &;

    &.k-c-checkbox { // 1
        :checked ~ #{$root}__box {
            border: 1px solid var(--k-gray-900);
            background-color: var(--k-gray-900);
        }

        #{$root}__label {
            text-align: left;
        }
    }
}
</style>
